import { useEffect, useState } from "react";
import { api } from "../lib/api";

export function HealthBadge() {
  const [status, setStatus] = useState("checking");
  useEffect(() => {
    let cancelled = false;
    const check = () =>
      api
        .get("/health")
        .then((r) => !cancelled && setStatus(r.data?.status === "ok" ? "ok" : "down"))
        .catch(() => !cancelled && setStatus("down"));
    check();
    const iv = setInterval(check, 30000);
    return () => {
      cancelled = true;
      clearInterval(iv);
    };
  }, []);
  return (
    <div
      className={`health-badge health-badge--${status}`}
      data-testid="health-badge"
      aria-label={`Backend ${status}`}
    >
      <span className="health-badge__dot" aria-hidden />
      <span>Backend: {status}</span>
    </div>
  );
}
